import React from "react";

const DEFAULT_LOGO = process.env.PUBLIC_URL + "/assests/HireWing.png";

function Footercomp() {
  return (
    <div className="mobile-footercomp">
      <div className="footer-container">
        <div className="powered-by-section">
          <p className="powered-by-text">Powered by</p>
          <div className="footer-logo">
            <img
              src={DEFAULT_LOGO}
              alt="Company logo"
              style={{
                maxWidth: "120px",
                maxHeight: "20px",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footercomp;
